import { Localization } from "../../../common/localizable-component";
import { InputLocalization } from "./input-types";
import { deepmerge } from "../../../utils/deep-merge";
import { FORM_LOCALIZATION } from "../../form/constants/form-i18n";

export const INPUT_LOCALIZATION: Localization<InputLocalization> = deepmerge(FORM_LOCALIZATION, {
  en: {
    dateFormat: "MM.dd.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "en-US",
    thousandsSeparator: ","
  },
  de: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "t",
    localeMonth: "m",
    localeYear: "j",
    locale: "de-DE",
    thousandsSeparator: "."
  },
  sv: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "sv-SE",
    thousandsSeparator: " "
  },
  nl: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "j",
    locale: "nl-NL",
    thousandsSeparator: "."
  },
  it: {
    dateFormat: "gg.MM.aaaa",
    localeDay: "g",
    localeMonth: "m",
    localeYear: "a",
    locale: "it-IT",
    thousandsSeparator: "."
  },
  hu: {
    dateFormat: "éééé.hh.nn.",
    localeDay: "n",
    localeMonth: "h",
    localeYear: "é",
    locale: "hu-HU",
    thousandsSeparator: " "
  },
  da: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "da-DK",
    thousandsSeparator: "."
  },
  fr: {
    dateFormat: "MM.jj.aaaa",
    localeDay: "j",
    localeMonth: "m",
    localeYear: "a",
    locale: "fr-FR",
    thousandsSeparator: " "
  },
  es: {
    dateFormat: "MM.dd.aaa",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "a",
    locale: "es-Es",
    thousandsSeparator: "."
  },
  pl: {
    dateFormat: "MM.dd.rrrr",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "r",
    locale: "pl-PL",
    thousandsSeparator: " "
  },
  ro: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "ro-RO",
    thousandsSeparator: "."
  },
  hr: {
    dateFormat: "MM.dd.gggg",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "g",
    locale: "hr-HR",
    thousandsSeparator: "."
  },
  cs: {
    dateFormat: "dd.MM.rrrr",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "r",
    locale: "cs-CS",
    thousandsSeparator: " "
  },
  sl: {
    dateFormat: "MM.dd.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "sl-SL",
    thousandsSeparator: "."
  }
});
